export enum WithinNameCell {
  TitleLine = 'TitleLine',
  SubtitleLine = 'SubtitleLine',
  BelowSubtitleLine = 'BelowSubtitleLine'
}
